import { createSlice } from '@reduxjs/toolkit';

export const dataSlice = createSlice({
  name: "data",
  initialState: {
    data: {},
    metadata: {}
  },
  reducers: {
    getMeta: (state, action) => {
      return {
        ...state,
        metadata: action.payload
      }
    },
    getData: (state, action) => {
      return {
        ...state,
        data: action.payload
      }
    }
  }
})

export const { getMeta, getData } = dataSlice.actions

export default dataSlice.reducer